import { render } from "./PagamentoRecargaRejeitada.vue?vue&type=template&id=734751e5"
import script from "./PagamentoRecargaRejeitada.vue?vue&type=script&lang=js"
export * from "./PagamentoRecargaRejeitada.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__